export default function scrollGsapImg() {
	if (window.matchMedia("(max-width: 1100px)").matches) return

	gsap.registerPlugin(ScrollTrigger);
	const
		gracieRowsWrapper = document.querySelector("#section-coming-soon .gracie-rows-wrapper");
        if (!gracieRowsWrapper) return
		const row1 = gracieRowsWrapper.querySelector(".row-1"),
		row2 = gracieRowsWrapper.querySelector(".row-2"),
		row3 = gracieRowsWrapper.querySelector(".row-3")

	const
		value = 200,
		duration = 30;


	gsap.set(row1, {
		x: - value
	}, "juntas")
	gsap.set(row2, {
		x: value
	}, "juntas")
	gsap.set(row3, {
		x: - value
	}, "juntas")

	const tl =
		gsap
			.timeline({ paused: true, delay: 0, ease: "linear", repeat: -1, yoyo: true, yoyoEase: false })
			.to(row1, {
				duration: duration,
				x: value
			}, "juntas")
			.to(row2, {
				duration: duration,
				x: - value
			}, "juntas")
			.to(row3, {
				duration: duration,
				x: value
			}, "juntas")
	
	window.tl = tl


	ScrollTrigger.create({
		trigger: gracieRowsWrapper,
		once: false,
		start: 'top-=100px',
		refreshPriority: 10,
		//markers: true,
		onEnter: function () {
			tl.play()

		},
	});
}